import { useEffect, useState } from "react";
import { DownloadHistory } from "../../axios";
import { DownloadLogHistory } from "../../axios";
import { DateUtils } from "../../utils/DateUtils";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";
import { HtmlUtils } from "../../utils/HtmlUtils";
import { ValueUtils } from "../../utils/ValueUtils";

/**
 * ダウンロード画面用コンポーネント
 * 
 * @returns 
 */
export default function DownloadPage(): JSX.Element {

	/** ダウンロード履歴一覧 */
	const [downloads, setDownloads] = useState<DownloadHistory[]>([]);

	/** ダウンロードログ履歴一覧 */
	const [downloadsLog, setDownloadsLog] = useState<DownloadLogHistory[]>([]);

	// 初回のみ実行
	useEffect(() => {
		void refreshList();
	}, []);

	/**
	 * 更新ボタンクリック時イベント
	 */
	const handleRefreshClick = () => {
		setDownloads([]);
		setDownloadsLog([]);
		void refreshList();
	}

	/**
	 * ダウンロードボタンクリック時イベント
	 * 
	 * @param id 
	 */
	const handleDownloadClick = async (id: string) => {
		try {
			const res = await DbUtils.getDownloadApi().getDownloadUrl(id);
			HtmlUtils.download(res.data.url!);

			// 表示も更新する。
			void refreshList();
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

		/**
	 * ログ用ダウンロードボタンクリック時イベント
	 * 
	 * @param id 
	 */
		const handleDownloadLogClick = async (id: string) => {
			try {
				// 
				const res = await DbUtils.getDownloadApi().getDownloadLogUrl(id);
				HtmlUtils.download(res.data.url!);
	
				// 表示も更新する。
				void refreshList();
			} catch (error) {
				ErrorUtils.alert(error);
			}
		};

	/**
	 * 一覧を更新する。
	 */
	const refreshList = async () => {
		const res = await DbUtils.getDownloadApi().getDownloads();
		const resLog = await DbUtils.getDownloadApi().getDownloadslog();
		setDownloads(res.data);
		setDownloadsLog(resLog.data);

	}

	/** 1行描画する。 */
	const renderRow = (download: DownloadHistory) => {

		const search = download.search_history!;
		return (
			<tr>
				<td>
					{download.combine_status == '2' &&
						<button className="btn btn-default btn-primary pull-center" type="button" onClick={() => handleDownloadClick(download._id!)}>ダウンロード</button>
					}
				</td>
				<td>アーカイブ</td>
				<td>{ValueUtils.getCombineStatusName(download.combine_status)}</td>
				<td>{ValueUtils.getDownloadStatusName(download.download_status)}</td>
				<td>{DateUtils.formatDateTime(download.combine_dttm)}</td>
				<td>{ValueUtils.fromByte(download.combine_file_size)}</td>
				<td>{ValueUtils.getConditionMessage(download.search_history).map(message => <>{message}<br /></>)}</td>
			</tr>
		);
	};

	/** ダウンロードログ1行描画する。 */
	const renderLogRow = (downloadLog: DownloadLogHistory) => {

		const searchlog = downloadLog.search_log_history!;
		return (
			<tr>
				<td>
					{downloadLog.combine_status == '2' &&
						<button className="btn btn-default btn-primary pull-center" type="button" onClick={() => handleDownloadLogClick(downloadLog._id!)}>ダウンロード</button>
					}
				</td>
				<td>ログ</td>
				<td>{ValueUtils.getCombineStatusName(downloadLog.combine_status)}</td>
				<td>{ValueUtils.getDownloadStatusName(downloadLog.download_status)}</td>
				<td>{DateUtils.formatDateTime(downloadLog.combine_dttm)}</td>
				<td>{ValueUtils.fromByte(downloadLog.combine_file_size)}</td>
				<td>{ValueUtils.getConditionLogMessage(downloadLog.search_log_history).map(message => <>{message}<br /></>)}</td>
			</tr>
		);
	};

	

	// 描画する
	return (
		<>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<h4>ダウンロード&nbsp;</h4>
				<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleRefreshClick} style={{ margin: '5px 0 3px 5px', width: '80px' }}>更新</button>
			</div>

			<hr />
			<div style={{ width: '100%' }}>
				<table width="100%" className="dlist" id="table01">
					<tbody>
						<tr>
							<th></th>
							<th>ダウンロード種別</th>
							<th>作成ステータス</th>
							<th>ダウンロード</th>
							<th>作成日時</th>
							<th>ファイルサイズ</th>
							<th>条件</th>
						</tr>
						{downloads.map(download => renderRow(download))}
						{downloadsLog.map(downloadLog => renderLogRow(downloadLog))}
					</tbody>
				</table>
			</div>
		</>
	);

}